module.exports = __webpack_public_path__ + "static/media/ups-vehicle.b106796a.jpg";